import { render, staticRenderFns } from "./CmgAccountModalCreateAccountSignIn.vue?vue&type=template&id=3bef8a90&scoped=true&lang=pug&"
import script from "./cmg-account-modal-create-account-sign-in.ts?vue&type=script&lang=ts&"
export * from "./cmg-account-modal-create-account-sign-in.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAccountModalCreateAccountSignIn.vue?vue&type=style&index=0&id=3bef8a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bef8a90",
  null
  
)

export default component.exports